module.exports = __webpack_public_path__ + "img/grid-srp-preview-kia.bc410382.png";